import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmPressedWithDot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19 12.4783V7.69565C19 5.91986 18.2625 4.21679 16.9497 2.96111C15.637 1.70543 13.8565 1 12 1C10.1435 1 8.36301 1.70543 7.05025 2.96111C5.7375 4.21679 5 5.91986 5 7.69565V12.4783C4.97026 14.8409 4.27968 17.1529 3 19.1739H21C19.7203 17.1529 19.0297 14.8409 19 12.4783Z",
			fill: "#161957",
			stroke: "#161957",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 5,
			r: 5,
			fill: "#45B8DD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 21.0869C9.22059 21.6467 9.62734 22.1311 10.1645 22.4736C10.7016 22.8161 11.3427 23 12 23C12.6573 23 13.2984 22.8161 13.8355 22.4736C14.3727 22.1311 14.7794 21.6467 15 21.0869H9Z",
			fill: "#161957"
		})
	]
});
export default SvgAlarmPressedWithDot;
